import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ChatService, Conversation } from '../../services/chat.service';
import { OpenApiService, ChatHistory } from '../../../../core/services/open-api.service';

@Component({
  selector: 'app-chat-history',
  templateUrl: './chat-history.component.html',
  styleUrls: ['./chat-history.component.scss']
})
export class ChatHistoryComponent implements OnInit {
  chatHistory: ChatHistory[] = [];
  templateId: string = '';

  constructor(
    public chatService: ChatService,
    private openApiService: OpenApiService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.route.queryParamMap.subscribe(params => {
      this.templateId = params.get('templateId') || '';
      if (this.templateId) {
        this.fetchChatHistory(this.templateId);
      }
      console.log('ChatHistoryComponent initialized', this.templateId);
    });
  }

  fetchChatHistory(templateId: string) {
    if (!this.templateId) return;
    console.log('Fetching chat history for templateId:', templateId);
    this.openApiService.getAllChatHistory(templateId).subscribe(history => {
      this.chatHistory = history || [];
    });
    console.log('Fetched chat history:', this.chatHistory);
  }

  newChat() {
    this.chatService.newChat();
    // Refresh chat history immediately after creating a new chat
    if (this.templateId) {
      this.fetchChatHistory(this.templateId);
    }
  }

  selectConversation(conversation: Conversation) {
    this.chatService.selectConversation(conversation);
  }

  deleteConversation(event: MouseEvent, chatThreadId: string) {
    event.stopPropagation();
    if (confirm('Are you sure you want to delete this chat?')) {
      if (chatThreadId) {
        this.openApiService.deleteChatHistory(chatThreadId).subscribe(() => {
          this.fetchChatHistory(this.templateId);
        });
      }
    }
  }
  // Select a chat thread and display its history in the chat window
selectChatThread(chatThreadId: string) {
  if (!chatThreadId) return;

  this.openApiService.getChatHistoryByThread(chatThreadId).subscribe((history: ChatHistory[]) => {
    if (history && history.length > 0) {
      // Reverse the history so oldest messages come first
      const reversedHistory = [...history].reverse();

      // Split user and bot messages for the chat window
      const messages = reversedHistory.flatMap(h => {
        const msgs = [
          { text: h.question, sender: 'user', timestamp: new Date(h.timestamp) } as any
        ];
        if (h.answer) {
          msgs.push({ text: h.answer, sender: 'bot', timestamp: new Date(h.timestamp) } as any);
        }
        return msgs;
      }) as any;

      const conversation: Conversation = {
        id: chatThreadId,
        title: reversedHistory[0].question?.substring(0, 25) + '...' || 'Chat',
        messages: messages,
        chatThreadId: chatThreadId
      };

      this.chatService.selectConversation(conversation);
    }
  });
}

}
